export class SearchResultLabel_EN {
    searchResult: {
        quotationFor: string;
        atText: string;
    }

    constructor() {
        this.searchResult = {
            quotationFor: "Quotation for",
            atText: "at"
        }
    }
}